import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

import { Container as SelectContainer } from '~/components/Form/Select/styles';
import grid from '~/styles/grid';

export default makeStyles((theme) => ({
  buttons: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
  typography: {
    marginTop: theme.spacing(10),
    fontFamily: ['"Exo 2"', 'sans-serif'].join(','),
  },
}));

export const Container = styled.div`
  font-family: 'Exo 2', sans-serif;

  h1 {
    font: 20px 'Exo 2', sans-serif;
  }

  > h1 {
    font-weight: normal;
    font-size: 24px;
    color: #4d4d4d;
    margin: 0.5rem 0 1.7rem 0;

    /* &::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: rgba(0, 0, 0, 0.1);
      margin: 16px 0 40px 0;
    } */
  }

  input {
    font-family: 'Exo 2', sans-serif;
  }

  p {
    font: 12px 'Exo 2', sans-serif;
  }

  h6 {
    font: 20px 'Exo 2', sans-serif;
    margin-bottom: 25px;
  }

  h2,
  h3,
  h4,
  h5,
  h6,
  label,
  value,
  span {
    font: 14px 'Exo 2', sans-serif;
  }

  label,
  h1 {
    color: #4d4d4d;
  }

  ${SelectContainer} {
    .react-select__control {
      height: 48px;
      font-size: 14px;
    }
  }
`;

export const Title = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  /* margin-left: 0.938rem;
  margin-bottom: -0.875rem; */
  cursor: pointer;

  margin-top: ${grid.lg};
  margin-bottom: ${grid.lg};
`;
